<template>
  <div>
    <b-modal
      :title="$t('Create Justification')"
      size="lg"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      v-model="show"
      @hidden="$emit('hidden')"
    >
      <b-row class="my-1">
        <b-col cols="6" lg="6" md="6" sm="12" xs="12">
          <validation-provider v-slot="{ errors }" name="justification_type">
            <b-form-group
              :label="$t('Justification Type')"
              :state="errors[0] ? false : null"
            >
              <v-select
                v-model="justification.justification_type_id"
                id="justification_type"
                :clearable="false"
                :reduce="(value) => value.id"
                label="name"
                :options="justificationTypes"
                :get-option-label="(option) => $t(option.name)"
              >
              </v-select>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="6" lg="6" md="6" sm="12" xs="12" v-if="mode === 'single'">
          <validation-provider name="start_date">
            <b-form-group :label="$t('Date')">
              <kendo-datepicker
                class="form-control-kendo"
                :format="'dd-MM-yyyy'"
                v-model="justification.start_date"
                autofocus
                :class="[isDarkSkin ? ' bg-transparent' : '', '']"
                disabled
              />
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col
          cols="6"
          lg="6"
          md="6"
          sm="12"
          xs="12"
          v-if="mode === 'multiple'"
        >
          <validation-provider name="start_date">
            <b-form-group :label="$t('Dates')">
              <flat-pickr
                v-model="dates"
                class="form-control"
                :config="{ mode: 'multiple', dateFormat: 'd-m-Y' }"
                :defaultDate="dates"
              />
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="6" lg="6" md="6" sm="12" xs="12">
          <validation-provider v-slot="{ errors }" name="file">
            <b-form-group :label="$t('File')" :state="errors[0] ? false : null">
              <b-form-file
                v-model="justification.file"
                :placeholder="$t('No file chosen...')"
                accept="image/jpeg, image/png, application/pdf"
                :browse-text="$t('Browse')"
              ></b-form-file>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col v-if="esTardanza" cols="6" lg="6" md="6" sm="12" xs="12">
          <validation-provider name="aplicar_descuento">
            <b-form-group label="¿Aplicar descuento por tardanza?">
              <b-form-checkbox
                class="mt-05"
                v-model="justification.aplicar_descuento"
                switch
              ></b-form-checkbox>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12">
          <validation-provider v-slot="{ errors }" name="observation">
            <b-form-group
              :label="$t('Observation')"
              :state="errors[0] ? false : null"
            >
              <b-form-textarea
                v-model="justification.observation"
                :rows="3"
                :max-rows="6"
                :placeholder="$t('Enter your text')"
              ></b-form-textarea>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" class="d-flex justify-content-end mt-2">
          <b-button
            variant="outline-danger"
            @click="$emit('hidden')"
            class="mr-1"
          >
            {{ $t("Cancel") }}
            <feather-icon icon="XIcon" size="16" />
          </b-button>

          <b-button
            variant="outline-success"
            @click="storeMarkScheduleJustification()"
          >
            {{ $t("Save") }}
            <feather-icon icon="SaveIcon" size="16" />
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import AttendanceService from "@/views/rrhh/views/attendance/services/attendance.service.js";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  props: {
    personal: {
      type: Object,
      required: true,
    },
    datesSelected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: true,
      mode: "single",
      dates: [],
      justificationTypes: [],
      justification: {
        justification_type_id: "",
        observation: "",
        employee_id: "",
        created_by: "",
        file: null,
        start_date: "",
        end_date: "",
        aplicar_descuento: false,
      },
      allowedRangeOfDates: [2, 4, 5, 8],
    };
  },
  mounted() {
    this.listJustificationTypes();
    this.justification.created_by = this.currentUser.id;

    if (this.mode === "single") {
      this.justification.start_date = this.personal.startDate;
    } else {
      // this.dates = this.datesSelected;
      // // parse to dd-mm-yyyy
      this.dates = this.datesSelected.map((date) => {
        return moment(date).format("DD-MM-YYYY");
      });
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    esTardanza() {
      return this.justification.justification_type_id == 3;
    },
  },
  methods: {
    async storeMarkScheduleJustification() {
      try {
        this.addPreloader();
        let form = new FormData();

        form.append(
          "justification_type_id",
          this.justification.justification_type_id
        );
        form.append("observation", this.justification.observation);
        form.append("employee_id", this.personal.personal_id);
        form.append("file", this.justification.file);
        form.append("created_by", this.currentUser.id);
        form.append("start_date", this.justification.start_date);
        form.append("end_date", this.justification.end_date);
        form.append("mode", this.mode);

        if (this.esTardanza) {
          form.append(
            "aplicar_descuento",
            this.justification.aplicar_descuento === true ? 1 : 0
          );
        }

        const { data } = await AttendanceService.storeMarkScheduleJustification(
          form
        );
        this.showToastSuccess(this.$t(data[0].Message));
        this.$emit("close");
      } catch (error) {
        if (error && "response") {
          let { status, data } = error.response;
          if (status === 422) {
            let keys = Object.keys(data.errors);
            keys.forEach((key) => {
              this.showToastError(data.errors[key][0], data.message);
            });
          }
        } else {
          this.showToastError(error);
        }

        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    async listJustificationTypes() {
      try {
        this.addPreloader();
        const { data } = await AttendanceService.listJustificationTypes();
        this.justificationTypes = data;
      } catch (error) {
        this.showToastError();
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>